/**
 * @ngdoc controllers
 * @memberof mercury.modules.reports
 * @name ReportsItemsCategoriesCtrl
 * @description A report with sales grouped by Item Category and report interval
 */
angular.module('mercury.modules.reports.items')
.controller('ReportsItemsCategoriesCtrl', ["$scope", "ReportItemCategories", "reporttime", "$filter", "title", function($scope, ReportItemCategories, reporttime, $filter, title) {
  reporttime.setAllowedTypes(['day', 'week', 'month']);
  reporttime.defaultType = 'week';
  title.set('Categories Report');

  $scope.loading = ReportItemCategories.getOrdersByInterval(reporttime.start(), reporttime.end(), reporttime.interval());
  $scope.loading.then(function(result) {
    $scope.graphCols = [
      {label: 'Time', type: 'string', key: 'startTime', filter: 'reporttimeformat'}
    ];

    $scope.extraColumns = [];

    angular.forEach(result, function(period) {
      angular.forEach(period.payload, function(itemCategory) {
        var visited = $filter('filter')($scope.extraColumns, {label: itemCategory.label});

        if (visited.length === 0) {
          var groupColumn = {label: itemCategory.label + ' Orders', type: 'number', key: itemCategory.label, filter: 'currency'};

          $scope.extraColumns.push(groupColumn);
          $scope.graphCols.push(groupColumn);
        }
      });
    });

    var rows = [];
    angular.forEach(result, function(period) {
      var row = {startTime: period.startTime, total: 0};
      angular.forEach($scope.extraColumns, function(column) {
        var group = $filter('filter')(period.payload, {label: column.key})[0];
        var orders = (group) ? group.amount : 0;

        row[column.key] = orders;
        row.total += orders;
      });

      rows.push(row);
    });
    $scope.rows = rows;
  });
}]);
